import React from 'react';
import { SliderForm } from '../../components/Slider';
import { Slider as SliderTemplate } from '../../components/Templates';
import { InteractiveWrapper } from '../../components/Interface';

export const Slider = () => {
    return (
      <InteractiveWrapper 
        name="slider"
        title="Slider"
        template={SliderTemplate}
        initFunction="initSlider"
        hasStyles={true}
        topPadding={true}
      >
        <SliderForm />
      </InteractiveWrapper>
    )
}
